import { render, staticRenderFns } from "./ValidarChaveSeguranca.vue?vue&type=template&id=d56e4fe4&"
import script from "./ValidarChaveSeguranca.vue?vue&type=script&lang=js&"
export * from "./ValidarChaveSeguranca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports